var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.getLink}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-download")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }